<div class="container bg-background-light mx-auto flex-1">
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
    
    <!-- Video Player Section -->
    <div class="lg:col-span-2" *ngIf="selectedVideo; else noVideo">
    
      <!-- Video -->
      <div class="bg-black rounded-xl overflow-hidden shadow-lg aspect-[16/9]">
        <video class="w-full h-full object-cover" controls [src]="selectedVideo.url" autoplay>
          Your browser does not support the video tag.
        </video>
      </div>
    
      <div class="mt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
    
        <!-- Left: Title & Module -->
        <div class="flex-1">
          <h1 class="text-2xl lg:text-3xl font-bold text-gray-900 dark:text-white line-clamp-2">
            {{ selectedVideo.title }}
          </h1>
          <div class="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Module: {{ selectedVideo.module }}
          </div>
        </div>
    
        <!-- Right: Like & Favorite -->
        <div class="flex items-center gap-6">

          <!-- video views -->
          <span class="flex items-center gap-1">
            <span class="material-symbols-outlined text-base">visibility</span>
            {{ viewsCount }} views
          </span>
    
          <!-- Like Button -->
          <button (click)="toggleLike()"
            class="flex items-center gap-2 transition-transform duration-300 ease-out cursor-pointer" [ngClass]="selectedVideo.likedByCurrentUser 
              ? 'text-blue-600 scale-105' 
              : 'text-gray-700 dark:text-gray-300 hover:text-blue-600'">
    
            <ng-container *ngIf="selectedVideo.likedByCurrentUser; else likeOutline">
              <!-- Filled Like -->
              <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 fill-current" viewBox="0 0 24 24">
                <path d="M1 21h4V9H1v12zM23 10c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32
                        c0-.41-.17-.79-.44-1.06L14.17 2 7.59 8.59C7.22 8.95 7 9.45 7 10v9
                        c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05
                        c.09-.23.14-.47.14-.73v0z" />
              </svg>
            </ng-container>
            <ng-template #likeOutline>
              <!-- Outline Like -->
              <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 fill-none stroke-current stroke-2" viewBox="0 0 24 24">
                <path d="M1 21h4V9H1v12zM23 10c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32
                        c0-.41-.17-.79-.44-1.06L14.17 2 7.59 8.59C7.22 8.95 7 9.45 7 10v9
                        c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05
                        c.09-.23.14-.47.14-.73v0z" />
              </svg>
            </ng-template>
            <span class="font-semibold text-black">{{ selectedVideo.likesCount || 0 }}</span>
          </button>
    
          <!-- Favorite Button -->
          <button (click)="toggleFavorite()"
            class="flex items-center gap-2 transition-transform duration-300 ease-out cursor-pointer" [ngClass]="selectedVideo.favoritedByCurrentUser 
              ? 'text-red-500 scale-105' 
              : 'text-gray-700 dark:text-gray-300 hover:text-red-500'">
    
            <ng-container *ngIf="selectedVideo.favoritedByCurrentUser; else heartOutline">
              <!-- Filled Heart -->
              <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 fill-current" viewBox="0 0 24 24">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5
                        2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09
                        C13.09 3.81 14.76 3 16.5 3
                        19.58 3 22 5.42 22 8.5
                        c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
              </svg>
            </ng-container>
            <ng-template #heartOutline>
              <!-- Outline Heart -->
              <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 fill-none stroke-current stroke-2" viewBox="0 0 24 24">
                <path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3
                        4.42 3 2 5.42 2 8.5
                        c0 3.78 3.4 6.86 8.55 11.54L12 21.35
                        l1.45-1.32C18.6 15.36 22 12.28 22 8.5
                        22 5.42 19.58 3 16.5 3z" />
              </svg>
            </ng-template>
            <span class="font-semibold text-black">{{ selectedVideo.favoritesCount || 0 }}</span>
          </button>
    
        </div>
      </div>
    
      <div class="mt-4 bg-white dark:bg-gray-800/50 p-4 rounded-xl shadow-sm">
        <div class="flex items-center justify-between cursor-pointer" (click)="isDescOpen = !isDescOpen">
          <h3 class="font-bold text-gray-900 dark:text-white">Description</h3>
          <span class="material-symbols-outlined transform transition-transform duration-300"
            [class.rotate-180]="isDescOpen">expand_more</span>
        </div>
        <p *ngIf="isDescOpen" class="mt-2 text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
          {{ selectedVideo.description }}
        </p>
      </div>
    
      <!-- Comments Section -->
      <div class="mt-6 bg-white dark:bg-gray-800/50 p-4 rounded-xl shadow-sm">
        <h3 class="font-bold text-gray-900 dark:text-white mb-3">Comments</h3>
    
        <!-- New Comment -->
        <div class="flex items-center gap-3 mb-4">
          <img *ngIf="user?.profile_image" [src]="user.profile_image" class="w-10 h-10 rounded-full" alt="User avatar" />
          <input type="text" [(ngModel)]="newComment" (keyup.enter)="postComment()" placeholder="Add a comment..."
            class="flex-1 bg-gray-100 dark:bg-gray-700 text-sm px-4 py-2 rounded-full outline-none focus:ring-2 focus:ring-primary" />
          <button (click)="postComment()"
            class="bg-primary text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-primary/90 cursor-pointer">Post</button>
        </div>
    
        <!-- Comment List -->
        <div *ngIf="comments.length > 0; else noComments">
          <div *ngFor="let c of selectedVideo.comments" class="mb-4 flex items-start gap-3">
            <img *ngIf="c.profile_image; else placeholder" [src]="c.profile_image"
              class="w-10 h-10 rounded-full object-cover" alt="{{ c.userInfo?.first_name }}" />
            <ng-template #placeholder>
              <div
                class="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold uppercase">
                {{ c.userName?.charAt(0) || '?' }}
              </div>
            </ng-template>
            <div>
              <p class="text-sm font-semibold text-gray-800 dark:text-gray-100">
                {{ c.userName }}
              </p>
              <p class="text-sm text-gray-600 dark:text-gray-400">{{ c.text }}</p>
            </div>
          </div>
        </div>
        <ng-template #noComments>
          <p class="text-sm text-gray-500 dark:text-gray-400">No comments yet.</p>
        </ng-template>
      </div>
    
    </div>

    <!-- Up Next Videos Section -->
    <div class="lg:col-span-1 space-y-8">
      <div class="bg-white dark:bg-gray-800/50 rounded-xl shadow-sm p-4">
        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-4">Up Next</h3>
        <div class="space-y-4 max-h-[600px] overflow-y-auto pr-2">
          <div *ngIf="upNextVideos.length === 0" class="text-gray-500 dark:text-gray-400">
            No videos available in this module.
          </div>
          <div *ngFor="let video of upNextVideos"
               class="flex gap-4 p-2 rounded-lg cursor-pointer transition-colors"
               [ngClass]="{'bg-primary/10 dark:bg-primary/20': video.url === selectedVideo.url,'hover:bg-gray-100 dark:hover:bg-gray-700/50': video.url !== selectedVideo.url}"
               (click)="playVideo(video)">
            <img class="w-32 h-20 object-cover rounded-md" 
                 [src]="video.thumbnail || 'https://via.placeholder.com/150'" 
                 [alt]="'Thumbnail for ' + video.title"/>
            <div class="flex-1">
              <h4 class="font-semibold text-gray-800 dark:text-white leading-tight">{{ video.title }}</h4>
              <p class="text-xs text-gray-600 dark:text-gray-400 mt-1">{{ video.module }}</p>
              <p class="text-xs text-gray-500 dark:text-gray-500 mt-1">{{ video.duration | duration }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Supporting Files / Details -->
      <div class="bg-white dark:bg-gray-800/50 rounded-xl shadow-sm p-4">
        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-4">Details</h3>
        <div class="space-y-4">
          <div>
            <h4 class="text-sm font-semibold text-gray-600 dark:text-gray-400">Related Documents</h4>
            <ul *ngIf="!!selectedVideo?.supportingFiles?.length; else noDocs" class="mt-2 space-y-1 text-sm">
              <li *ngFor="let file of selectedVideo.supportingFiles">
                <a class="flex items-center gap-2 text-primary hover:underline" [href]="file" target="_blank" rel="noopener noreferrer">
                  <span class="material-symbols-outlined text-base">{{ getFileIcon(file) }}</span>
                  {{ extractFileName(file) }}
                </a>
              </li>
            </ul>
            <ng-template #noDocs>
              <p class="text-sm text-gray-500 dark:text-gray-400 mt-2">No related documents available.</p>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <ng-template #noVideo>
      <p class="text-red-500">No video selected</p>
    </ng-template>

  </div>
</div>
